import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  }
  ,
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },


  //contacts routes
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("@/views/Contacts/ContactList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/contacts/:id/view",
    name: "ContactView",
    component: () => import("@/views/Contacts/ContactView.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //partners routes
  {
    path: "/partners",
    name: "Partners",
    component: () => import("../views/Partners/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/partners/create",
    name: "PartnerCreate",
    component: () => import("../views/Partners/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/partners/:id/edit",
    name: "PartnerEdit",
    component: () => import("../views/Partners/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //insurances routes
  {
    path: "/insurances",
    name: "Insurances",
    component: () => import("../views/Insurances/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/insurances/create",
    name: "InsuranceCreate",
    component: () => import("../views/Insurances/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/insurances/:id/edit",
    name: "InsuranceEdit",
    component: () => import("../views/Insurances/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;
